export default __webpack_public_path__ + "static/banner-media-release-nov8-2b8fee2b83fc751ec7ad1d76784835dd.jpg";